/**
 * FeatureHighlights - WIA Book Universal Reader 주요 기능 섹션
 * 홍익인간 (Hongik Ingan) - WIA Standards
 */

import { useI18n } from '../../i18n';

const FeatureHighlights = () => {
  const { t } = useI18n();

  const highlights = [
    {
      icon: '📚',
      titleKey: 'features.integrated',
      titleFallback: 'PDF · EPUB · EPUB3 통합',
    },
    {
      icon: '🎬',
      titleKey: 'features.flipbook',
      titleFallback: '6종 3D 페이지 효과',
    },
    {
      icon: '⚙️',
      titleKey: 'features.customize',
      titleFallback: '12테마 · 5글꼴 커스터마이징',
    },
    {
      icon: '🔊',
      titleKey: 'features.tts',
      titleFallback: 'TTS 음성 읽기',
    },
    {
      icon: '🎵',
      titleKey: 'features.audio',
      titleFallback: '배경음악 6종 재생',
    },
    {
      icon: '💬',
      titleKey: 'features.notes',
      titleFallback: '하이라이트 · 메모 · 북마크',
    },
    {
      icon: '📱',
      titleKey: 'features.sync',
      titleFallback: 'QR 기기간 동기화',
    },
    {
      icon: '🌍',
      titleKey: 'features.languages',
      titleFallback: '211개 언어 지원',
    },
    {
      icon: '♿',
      titleKey: 'features.a11y',
      titleFallback: 'WAI-ARIA 완전 접근성',
    },
    {
      icon: '🌐',
      titleKey: 'features.browser',
      titleFallback: '브라우저 기반 · 설치 불필요',
    },
  ];

  return (
    <section className="bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 py-12">
      <div className="container mx-auto px-4">
        {/* Section Title */}
        <div className="text-center mb-8">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
            {t('features.title') || 'WIA Book Universal 주요 기능'}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 text-sm">
            {t('features.subtitle') || '세계 최초 PDF · EPUB · EPUB3 · Flipbook 통합 뷰어'}
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
          {highlights.map((item, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-800/50 rounded-xl p-4 text-center hover:shadow-md transition-shadow"
            >
              <div className="text-3xl mb-2">{item.icon}</div>
              <p className="text-xs font-medium text-gray-700 dark:text-gray-300 leading-tight">
                {t(item.titleKey) || item.titleFallback}
              </p>
            </div>
          ))}
        </div>

        {/* Tagline */}
        <div className="text-center mt-8">
          <p className="text-sm text-gray-500 dark:text-gray-500 italic">
            💜 {t('features.tagline') || '홍익인간 (Hongik Ingan) - 널리 인간을 이롭게 하다'}
          </p>
        </div>
      </div>
    </section>
  );
};

export default FeatureHighlights;
